import { postRequestWithAuth, getRequestWithAuth } from "../api";
import { GamgeeChatSession, GamgeeChatSessionRead } from "~/types/session";

export const initiateTechnicalSession = async (
  title: string
): Promise<GamgeeChatSession> => {
  const response = await postRequestWithAuth(
    '/api/v1/technical/initiateTechnicalSession',
    { title }
  );
  return response;
};

export const getTechnicalSession = async (
  sessionId: string
): Promise<GamgeeChatSessionRead> => {
  const response = await getRequestWithAuth(
    `/api/v1/technical/session/${sessionId}`
  );
  return response;
};

export const getSandboxStatus = async (
  sessionId: string
): Promise<{ status: string; tunnel_url?: string; notebook_auth_token?: string }> => {
  const response = await getRequestWithAuth(
    `/api/v1/technical/getSandboxStatus?session_id=${sessionId}`
  );
  return response;
};
